import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconChevronLeft } from '@/components/Icon';

type Props = {
  title?: string;
  subtitle?: string;
  right?: ReactNode;
  onBack?: () => void;
};

export function BackHeader({ title, subtitle, right, onBack }: Props) {
  const navigate = useNavigate();
  return (
    <header className="flex items-center gap-2 mb-2">
      <button
        onClick={() => (onBack ? onBack() : navigate(-1))}
        className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-brand-orange"
        aria-label="Retour"
      >
        <IconChevronLeft size={22} />
      </button>
      <div className="flex-1 min-w-0">
        {title && <h1 className="text-xl font-semibold truncate">{title}</h1>}
        {subtitle && (
          <p className="text-xs text-white/60 truncate">{subtitle}</p>
        )}
      </div>
      {right}
    </header>
  );
}
